import { Injectable, signal } from '@angular/core';
import { Observable, map } from 'rxjs';

import { HeaderTokenAuthTokenResponse } from '../../interfaces/header-token-auth-token-response';
import { SemrushIframeService } from '../semrush-iframe/semrush-iframe.service';
import { WindowRefService } from '@callrail/looky/util';
import { tap } from 'rxjs/operators';

type IdentityProvider = 'semrush' | 'semrush_va';

@Injectable({
  providedIn: 'root',
})
export class HeaderTokenAuthService {
  public jwt: string;
  private idpSig = signal<IdentityProvider>(null);
  public idp = this.idpSig.asReadonly();

  constructor(
    private semrushIframesService: SemrushIframeService,
    windowRef: WindowRefService
  ) {
    if (windowRef.inVaIframe()) {
      this.idpSig.set('semrush_va');
    } else if (windowRef.inSemrushIframe()) {
      this.idpSig.set('semrush');
    }
    // if inVaIframe is true then so is inSemrushIframe
    if (windowRef.inSemrushIframe()) {
      this.semrushIframesService.semrushToken$.subscribe({
        next: (token) => (this.jwt = token),
      });
    }
  }

  public authenticate(): Observable<HeaderTokenAuthTokenResponse> {
    switch (this.idp()) {
      case 'semrush':
      case 'semrush_va':
        return this.semrushIframesService.refreshToken().pipe(
          tap((jwt: string) => (this.jwt = jwt)),
          map((jwt: string) => ({ jwt }))
        );
    }
  }

  public callTrkAuthorizationHeader(): string {
    switch (this.idp()) {
      case 'semrush':
        return 'SemrushTokenAuth';
      case 'semrush_va':
        return 'SemrushVaTokenAuth';
    }
  }
}
